var map = {
	"./0.png": "v7xU",
	"./1.png": "Txl5",
	"./10.png": "3AJl",
	"./11.png": "wByk",
	"./12.png": "YSwa",
	"./13.png": "6UKO",
	"./14.png": "7qTC",
	"./15.png": "ZV8N",
	"./2.png": "UT21",
	"./3.png": "U+2z",
	"./4.png": "8y5t",
	"./5.png": "bj4H",
	"./6.png": "QFQK",
	"./7.png": "12Qd",
	"./8.png": "01Ob",
	"./9.png": "K1s7",
	"./bg.png": "yRcn",
	"./butten_facebook.png": "ZV1J",
	"./butten_get_en.png": "SX1Q",
	"./butten_googleplay.png": "l1+r",
	"./butten_icon_facebook.png": "3tyU",
	"./butten_icon_line.png": "QB20",
	"./butten_icon_share.png": "nQLJ",
	"./butten_icon_twitter.png": "HoH+",
	"./butten_ios.png": "uO/O",
	"./butten_line.png": "puRo",
	"./butten_share_en.png": "NEJC",
	"./butten_sharebg.png": "XhhE",
	"./butten_twitter.png": "PROQ",
	"./copy.png": "zOHj",
	"./finishpic.png": "qi3n",
	"./logout_butten.png": "3B19",
	"./pupup_x.png": "yFFV",
	"./puzzle_bg.png": "N5dL",
	"./resultspage_bg.png": "sqBM",
	"./tip.png": "GH0F",
	"./titlepic_bg.png": "Xj7b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 2